exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-block[data-v-00f292d2] {\n  padding: 0 !important;\n}\n", ""]);

// exports
